import { defineComponent as _defineComponent } from 'vue'
import { beneficiaryTypeLabels, beneficiaryName, FeePaymentType } from 'ah-api-gateways';
import CurrencyFundingFee from 'ah-trades/src/components/fees/CurrencyFundingFee.vue';
import { TradeDestination } from '../forms/tradeDestination';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';
import { useTradeState } from '../..';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeBeneficiaryInfo',
  props: {
    tradeDestination: null,
    cols: { default: 4 }
  },
  setup(__props: any) {

const props = __props as { tradeDestination: Partial<TradeDestination> | TradeDestination, cols: string | number };



const tradeState = useTradeState();

tradeState.store.useSettingsStore().loadRoutingCodeTypes();

const beneficiary = computed(() => {
  return props.tradeDestination.beneficiary!;
});

const routingCode = computed(() => {
  const routingData = tradeState.store
    .useSettingsStore()
    .routingCodes.find((r) => r.currency === beneficiary.value.currency);
  if (routingData) {
    return routingData.title;
  }
  return 'Routing Code';
});

return { __sfc: true,props, tradeState, beneficiary, routingCode, beneficiaryTypeLabels, beneficiaryName, FeePaymentType, CurrencyFundingFee, countryNameFromCC }
}

})